import { Popover } from 'bootstrap';

;(function ($) {
    'use strict';

    const pluginName = 'annotations';

    function Plugin(elements) {
        this._name = pluginName;
        this.elements = $(elements);
        this.templates = {};

        this.init();
        return this;
    }

    $.extend(Plugin.prototype, {
        getTemplate(id) {
            if (this.templates[id] === undefined) {
                this.templates[id] = _.template($('#' + id).html());
            }

            return this.templates[id];
        },
        init: function () {
            if (this.elements.length === 0) {
                return;
            }

            const that = this;
            this.elements.each(function () {
                if ($(this).data(pluginName + '_done')) {
                    return;
                }

                $(this).data(pluginName + '_done', true);

                let itemId = $(this).data('item-id');
                if (itemId === '' || itemId === undefined) {
                    return;
                }

                let annotations = $(this).data('annotations')

                const tmplId = $(this).data('annotations-tmpl') ?? 'tpl--annotations--default'
                const tmpl = that.getTemplate(tmplId);

                $(this).on('buy-data-loaded', function (e) {
                    const price = e.price;
                    if (price && !price.isDiscountable && !annotations.includes(10)) {
                        annotations.push(10);
                    }

                    if (annotations.length === 0) {
                        return;
                    }

                    annotations.sort(function(a, b) {
                        return a - b;
                    });

                    const annotationsWithText = []
                    for (let i = 0; i < annotations.length; i++) {
                        const a = annotations[i];
                        const content = $('[data-annotation-target="' + a + '"]').parent('li').clone();
                        content.find('[data-annotation-target]').remove();
                        annotationsWithText.push('<div>' + content.html() + '</div>');
                    }

                    const label = $(this).data('annotations-label');
                    $(this).html(tmpl({annotations, annotationsWithText, label}));
                    const popoverContent = $(this).find('*[data-annotations-popover]').html()
                    if (popoverContent) {
                        const popover = Popover.getOrCreateInstance(this, {
                            container: 'body',
                            html: true,
                            placement: 'top',
                            content: popoverContent,
                            title: '',
                            trigger: 'hover focus',
                            delay: { "show": 200, "hide": 0 }
                        });
                    }

                    window.updateAnnotations();
                });
            })
        }
    });

    /**
     * Plugin Wrapper
     *
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function (options) {
        if (options === undefined || typeof options === 'object') {
            return $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
    };
})(jQuery);
